import { Switch, Route, useLocation } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";
import NotFound from "@/pages/not-found";
import Home from "@/pages/Home";
import Professional from "@/pages/Professional";
import Portfolio from "@/pages/Portfolio";
import ProjectPage from "@/pages/ProjectPage";
import ActivityPage from "@/pages/ActivityPage"; // Added import for ActivityPage
import CertificatePage from "@/pages/CertificatePage"; // Added import for CertificatePage
import UnderTheHood from "@/pages/UnderTheHood"; // Added import for UnderTheHood
import CompanyPage from "@/pages/CompanyPage"; // Added import for CompanyPage
import SkillDetailsPage from "@/pages/SkillDetailsPage"; // Added import for SkillDetailsPage
import Navigation from "@/components/Navigation";
import LoadingScreen from "@/components/LoadingScreen";
import CSSStarfieldBackground from "@/components/CSSStarfieldBackground";

function Router() {
  const [location] = useLocation();
  const isHomePage = location === '/';

  // Scroll to top when location changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div 
      className={`min-h-screen ${isHomePage ? '' : 'bg-background'}`}
      style={isHomePage ? { background: 'transparent' } : undefined}
    >
      {/* Conditional background rendering */}
      {isHomePage ? <CSSStarfieldBackground /> : null}
      <Navigation />
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/professional" component={Professional} />
        <Route path="/professional/:companySlug" component={CompanyPage} />
        <Route path="/professional/skill/:skillName" component={SkillDetailsPage} /> {/* Added route for SkillDetailsPage */}
        <Route path="/portfolio" component={Portfolio} />
        <Route path="/project/:id" component={ProjectPage} />
        <Route path="/activities/:slug" component={ActivityPage} /> {/* Updated route to use slug instead of id */}
        <Route path="/certificate/:id" component={CertificatePage} /> {/* Added route for CertificatePage */}
        <Route path="/under-the-hood" component={UnderTheHood} /> {/* Added route for UnderTheHood */}
        <Route component={NotFound} />
      </Switch>
    </div>
  );
}

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate initial loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <AnimatePresence mode="wait">
          {isLoading ? (
            <LoadingScreen />
          ) : (
            <Router />
          )}
        </AnimatePresence>
        <Toaster />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;